"use client";

import { VisualEditing } from "next-sanity";
import dynamic from "next/dynamic";

const DisableDraftMode = dynamic(() => import("./DisableDraftMode"));

export default function VisualEditingComp() {
    return (
        <>
            <VisualEditing />
            <DisableDraftMode />
        </>
    );
}
